import styled from 'styled-components'

export const DynamicGridWrapper = styled.div`
  text-align: center;
  margin-bottom: 6.4rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 8rem;
  }

  h3 {
    &:after {
      content: '';
      display: block;
      height: 0.1rem;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 25rem;
      margin: 2rem auto 0;
    }
  }

  .grid-container {
    display: flex;
    margin-top: 5rem;
    flex-wrap: wrap;
    flex-direction: column;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .grid-item {
    flex: 1 0 50%;
    text-align: left;
    margin-bottom: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      /* For older browsers, set fixed width */
      flex: 0 1 calc(50% - 1.6rem);
    }

    h4 {
      margin-top: 1rem;
      margin-bottom: 0.4rem;
    }
  }

  .description {
    p {
      margin-bottom: 2rem;
      font-size: 1.4rem;
    }
  }

  .dynamicGrid {
    display: flex;
    text-align: left;
    flex-direction: column;
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;
    }

    /* Microsoft IE10 and above */
    @media all and (-ms-high-contrast: none) {
      /* Fix IE11 image stretch issue */
      img {
        width: 50%;
        flex-shrink: 0;
      }
    }

    h4 {
      margin-top: 1rem;
      margin-bottom: 0.5rem;

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        margin-top: 0;
      }
    }
    img {
      margin-right: 3.2rem;
      max-width: 453px;
    }
  }
`
